/**
 * FigureGrid — a gallery of figures in a responsive grid (e.g. the biomimicry
 * cluster). Columns, not a stack. Composes Figure (cover tiles). Tokens only.
 */
import { Figure } from './Figure';
import type { FigureProps } from './Figure';
import { cn } from '../../utils';

export interface FigureGridProps {
  readonly figures: readonly FigureProps[];
  readonly columns?: 2 | 3 | 4;
}

export function FigureGrid({ figures, columns = 2 }: FigureGridProps) {
  const cols = { 2: 'sm:grid-cols-2', 3: 'sm:grid-cols-2 lg:grid-cols-3', 4: 'grid-cols-2 lg:grid-cols-4' }[columns];
  return (
    <div className={cn('grid grid-cols-1 gap-(--space-grid)', cols)}>
      {figures.map((f, i) => (
        <Figure key={i} {...f} bare cover />
      ))}
    </div>
  );
}
